<template>
  <form action="https://researchassistant.us19.list-manage.com/subscribe/post" method="POST">
    <input type="hidden" name="u" value="b7734d5f557417ad998f424a3">
    <input type="hidden" name="id" value="fcb7b87be8">

    <!-- people should not fill these in and expect good things -->
    <div class="field-shift" aria-label="Please leave the following three fields empty">
      <label for="b_name">Name: </label>
      <input type="text" name="b_name" tabindex="-1" value="" placeholder="Freddie" id="b_name">

      <label for="b_email">Email: </label>
      <input type="email" name="b_email" tabindex="-1" value="" placeholder="youremail@gmail.com" id="b_email">

      <label for="b_comment">Comment: </label>
      <textarea name="b_comment" tabindex="-1" placeholder="Please comment" id="b_comment"></textarea>
    </div>

    <div id="mergeTable" class="mergeTable">
    <div class="mergeRow dojoDndItem mergeRow-email" id="mergeRow-0">
      <label for="MERGE0">Blijf op de hoogte van updates</label>
        <div class="field-group">
          <input type="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value="" placeholder="Jouw e-mailadres">
        </div>
    </div>
    </div>
    <div class="submit_container clear">
      <input type="submit" class="formEmailButton" name="submit" value="Aanmelden">
    </div>
      <input type="hidden" name="ht" value="ee6b223acb3620d4a43b95c1c9006fb328075c2a:MTU0MTUwNjczMy4yNjU1">
      <input type="hidden" name="mc_signupsource" value="hosted">
  </form>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Newsletter'
}
</script>

<style scoped>
form {
  margin-top: 10px;
}

input,
label,
select,
button,
textarea {
	margin: 0;
	border: 0;
	padding: 0;
	display: inline-block;
	vertical-align: middle;
	white-space: normal;
	background: none;
  line-height: 1;
	/* Browsers have different default form fonts */
	font-size: 13px;
	font-family: 'Flaco-mono';
  color: #707070;
}

input:focus {
	outline: 0;
}

#MERGE0 {
  border-bottom : 2px dotted #707070 !important; 
  margin-top: 0.3rem;
  width: 70% !important;
}

.formEmailButton {
  background: #484848;
  color: #a4a4a4;
  padding: 5px;
  margin-top: 8px;
}

.field-shift {
  display: none;
}

.field-group {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Newsletter.vue